/**
 * Ecom Lab Demo Hub - Entry Point
 * 
 * KILL SWITCH: Set DEMO_HUB_ENABLED to false to disable entirely.
 * DELETE: Remove this folder and the route in App.js to fully remove.
 * 
 * @module demos/ecom-lab
 */

// Kill switch - set to false to disable the entire demo hub
export const DEMO_HUB_ENABLED = true;

export { default as DemoHub } from './DemoHub';
export { default as mockProducts } from './data/mockProducts';
